import React from 'react';
import { Progress } from 'antd';

const MiniProgress = ({ 
  percent = 0, 
  target = 100, 
  color = '#1890ff', 
  height = '8px',
  showInfo = false 
}) => {
  return (
    <div style={{ height: height }}>
      <Progress
        percent={percent}
        strokeColor={color}
        showInfo={showInfo}
        strokeWidth={parseInt(height)}
        style={{ lineHeight: height }}
      />
    </div>
  );
};

export default MiniProgress;
